export const state = {
  projectsFolderToDelete: {},
  projectsFolderDeleteDialogIsOpen: false,
  projectsFolderDeletePending: false,
}
